import React from 'react'
import { Link, useLocation } from 'react-router-dom';

function Nav() {
    const location = useLocation();
    
    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            const headerHeight = 100; // Înălțimea aproximativă a header-ului
            const elementPosition = element.offsetTop - headerHeight;
            
            window.scrollTo({
                top: elementPosition,
                behavior: 'smooth'
            });
        }
    };

    const handleNavClick = (e, sectionId, path) => {
        if (location.pathname === '/') {
            // Suntem pe pagina principală, facem scroll
            e.preventDefault();
            scrollToSection(sectionId);
            // Adăugăm hash în URL
            window.history.pushState(null, null, `#${sectionId}`);
        } else {
            // Suntem pe altă pagină, navigăm la pagina principală cu hash
            e.preventDefault();
            window.location.href = `/#${sectionId}`;
        }
    };

    return (
        <div>
            <nav className="nav-main mainmenu-nav d-none d-xl-block">
                <ul className="mainmenu">
                    <li>
                        <Link 
                            className="nav-item" 
                            to={'/'}
                            onClick={(e) => handleNavClick(e, 'banner', '/')}
                        >
                            Acasă
                        </Link>
                    </li>
                    <li>
                        <Link 
                            className="nav-item" 
                            to={'/about-us'}
                            onClick={(e) => handleNavClick(e, 'about', '/about-us')}
                        >
                            Despre Noi
                        </Link>
                    </li>
                    <li>
                        <Link 
                            className="nav-item" 
                            to={'/careers'}
                            onClick={(e) => handleNavClick(e, 'services', '/careers')}
                        >
                            Proiecte
                        </Link>
                    </li>
                    <li>
                        <Link 
                            className="nav-item" 
                            to={'/careers'}
                            onClick={(e) => handleNavClick(e, 'careers', '/careers')}
                        >
                            Carieră
                        </Link>
                    </li>
                    <li>
                        <Link 
                            className="nav-item" 
                            to={'/contactus'}
                            onClick={(e) => handleNavClick(e, 'f-contact', '/contactus')}
                        >
                            Contact
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    )
}

export default Nav